<!-- Create Appointment -->

<div class="modal-header flex-column pb-0">
  <div class="d-flex align-items-center justify-content-between w-100 mb-2">
    <h5 class="modal-title">{{ IsEditPatient ? 'Edit Patient' : 'Add Patient' }}</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
</div>
<div class="modal-body">
  <form class="row g-3" [formGroup]="PatientForm">
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="text" class="form-control" id="firstName" formControlName="firstName" placeholder="First Name" />
        <label for="patientName">First Name</label>
        <span *ngIf="PatientForm.get('firstName')?.touched && PatientForm.get('firstName')?.invalid" class="text-danger"> First Name is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="text" class="form-control" id="lastName" formControlName="lastName" placeholder="Last Name" />
        <label for="patientName">Last Name</label>
        <span *ngIf="PatientForm.get('lastName')?.touched && PatientForm.get('lastName')?.invalid" class="text-danger"> Last Name is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="text" [value]="PatientForm.get('phoneNumber')?.value | phonenumber : 'format'" class="form-control" id="phoneNumber" formControlName="phoneNumber" placeholder="Phone Number" />
        <label for="Phone">Phone Number</label>
        <span *ngIf="PatientForm.get('phoneNumber')?.touched && PatientForm.get('phoneNumber')?.invalid" class="text-danger"> Phone Number is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="date" class="form-control" id="dateOfBirth" formControlName="dateOfBirth" placeholder="dateOfBirth" />
        <label for="dob">Birth Date</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="date" class="form-control" id="dateOfAccident" formControlName="dateOfAccident" placeholder="dateOfAccident" />
        <label for="da">D/A</label>
        <span *ngIf="PatientForm.get('dateOfAccident')?.touched && PatientForm.get('dateOfAccident')?.invalid" class="text-danger"> Date Of Accident is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2">
        <input type="date" class="form-control" id="dateOfEntry" placeholder="dateOfEntry" formControlName="dateOfEntry" />
        <label for="de">D/E</label>
        <span *ngIf="PatientForm.get('dateOfEntry')?.touched && PatientForm.get('dateOfEntry')?.invalid" class="text-danger"> Date Of Entry is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="oV_W" placeholder="OV/W" formControlName="oV_W" />
        <label for="oV_W">OV/W</label>
        <span *ngIf="PatientForm.get('oV_W')?.touched && PatientForm.get('oV_W')?.invalid" class="text-danger"> OV/W is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <select class="form-select" id="caseType" aria-label="Case Type" formControlName="caseType">
          <option *ngFor="let option of caseTypeOptions" [value]="option.key">
            {{ option.value }}
          </option>
        </select>
        <label for="caseType">Case Type</label>
        <span *ngIf="PatientForm.get('caseType')?.touched && PatientForm.get('caseType')?.invalid" class="text-danger"> Date Of Entry is required </span>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled" />
        <label class="form-check-label" for="disabled"> Disabled </label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="transportation" formControlName="transportation" />
        <label class="form-check-label" for="transportation"> Transportation </label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="non_Compliant" formControlName="non_Compliant" />
        <label class="form-check-label" for="non_Compliant"> Non Compliant </label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="address" formControlName="address" placeholder="Address" />
        <label for="town">Address</label>
        <span class="text-danger" *ngIf="PatientForm.get('address')?.invalid && PatientForm.get('address')?.touched"> Address is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="town" formControlName="town" placeholder="Town" />
        <label for="town">Town</label>
        <span class="text-danger" *ngIf="PatientForm.get('town')?.invalid && PatientForm.get('town')?.touched"> Town is required </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <input (keydown)="sharedService.validateNumber($event)" type="text" class="form-control" id="zip" [maxlength]="MaxZipLength" formControlName="zip" placeholder="ZIP Code" />
        <label for="zip">ZIP Code</label>
        <div *ngIf="PatientForm.get('zip')?.invalid && PatientForm.get('zip')?.touched">
          <span class="text-danger" *ngIf="PatientForm.get('zip')?.errors?.['required']">ZIP is required.</span>
          <span class="text-danger" *ngIf="PatientForm.get('zip')?.errors?.['pattern']">Enter a valid 5-digit ZIP code.</span>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <textarea class="form-control" id="note" formControlName="note" placeholder="Enter note" rows="3"></textarea>
        <label for="note">Note</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating mb-3">
        <select class="form-select" id="clinicId" aria-label="clinicId" formControlName="clinicId" (change)="onSelectClinic($event)">
          <option *ngFor="let clinic of Clinincs" [value]="clinic?.id">
            {{ clinic?.clinicName }}
          </option>
        </select>
        <label for="attorneyId">Clinic Name</label>
        <span *ngIf="PatientForm.get('clinicId')?.touched && PatientForm.get('clinicId')?.invalid" class="text-danger"> Clinic Name is required </span>
      </div>
    </div>
    <div class="col-md-6" *ngIf="currentClinic">
      <div class="form-floating mb-3">
        <select class="form-select" id="attorneyId" aria-label="attorneyId" formControlName="attorneyId">
          <option [value]="0">-- None --</option>
          <option *ngFor="let attorney of attorneyList" [value]="attorney?.id">
            {{ attorney?.attorneyName }}
          </option>
        </select>
        <label for="attorneyId">Attorney</label>
        <span *ngIf="PatientForm.get('attorneyId')?.touched && PatientForm.get('attorneyId')?.invalid" class="text-danger"> Attorney is required </span>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer justify-content-between align-items-center">
  <div class="d-flex gap-2" *ngIf="IsEditPatient && !IsLoading">
    <button *ngIf="!PatientDetails.isDischarged" type="button" class="btn btn-danger" (click)="DischargePatient()">Discharge Patient</button>
    <button *ngIf="PatientDetails.isDischarged" type="button" class="btn btn-primary" (click)="ReactivePatient()">Re-active Patient</button>
    <button type="button" class="btn btn-outline-primary" (click)="OpenApptDialogue()">View Appointments</button>
  </div>

  <div class="d-flex gap-2 flex-grow-1 justify-content-end">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="IsEditPatient ? UpdatePatient() : AddPatient()"
      [disabled]="IsEditPatient ? PatientForm.invalid || PatientDetails.isDischarged : false"
      data-bs-dismiss="modal"
    >
      {{ IsEditPatient ? 'Save changes' : 'Add patient' }}
    </button>
  </div>
</div>
